



import { Component, Prop, Vue } from 'vue-property-decorator';
import { marked } from 'marked';
// Enable breaks option globally for marked
marked.setOptions({ breaks: true });

@Component({
  components: {},
})
export default class MdComponent extends Vue {
  @Prop({ required: true, type: [String] })
  readonly content!: string;

  get parsedContent() {
    // Replace 2 or more consecutive newlines with <br><br>
    const preProcessed = this.content.replace(/\n{2,}/g, (match) => '<br>'.repeat(match.length));
    const parsed = marked.parse(preProcessed);
    return parsed;
  }
}
